import React from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import "./RecipeGrid.css"; // You can still use custom styles if needed
import { styled } from "@mui/system";

const StyledCardMedia = styled(CardMedia)({
  height: "200px",
  objectFit: "cover",
  // other styles
});

const StyledCardContent = styled(CardContent)({
  height: "100px",
  // other styles
});

const RecipeGrid = ({ recipes, onRecipeSelect }) => {
  return (
    <Grid container spacing={3} className="recipe-grid">
      {recipes.map((recipe) => (
        <Grid item xs={6} sm={4} md={2.4} key={recipe.id}>
          {" "}
          {/* Adjusted for 2 on phones, ~5 on desktop */}
          <Card
            className="recipe-card"
            onClick={() => onRecipeSelect(recipe.id)}
          >
            <CardActionArea>
              <StyledCardMedia
                component="img"
                image={recipe.image || "/img/default.png"}
                alt={recipe.name}
                style={{ height: "200px", objectFit: "cover" }}
              />
              <StyledCardContent style={{ height: "100px" }}>
                {" "}
                <Typography gutterBottom variant="h5" component="h2">
                  {recipe.name}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="p"
                  className="recipe-description"
                >
                  {recipe.description}
                </Typography>
              </StyledCardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default RecipeGrid;
